module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.ttf
// module id = 818
// module chunks = 3